import React from 'react'
import {Navigate, Route, Routes} from 'react-router-dom'
import {PageTitle} from '../../../_metronic/layout/core'
import {useAuth} from '../../modules/auth'
import {shouldDisplayFonctionnalite} from '../../../components/helpers'
import SavReferentielsPage from './parametres/SavReferentielsPage'
import SavMessagesPage from './parametres/SavMessagesPage'
import SavListPage from './liste/SavListPage'
import SavSaisiePage from './saisie/SavSaisiePage'
import SavQualificationPage from './dossier/SavQualificationPage'
import SavFichePage from './dossier/SavFichePage'
import SavSolutionPage from './dossier/SavSolutionPage'
import SavReceptionPage from './reception/SavReceptionPage'
import SavControlePage from './controle/SavControlePage'

const fil = [{title: 'SAV', path: '/sav/liste', isSeparator: false, isActive: false}]

// Routes du module SAV (/sav/*)
const SavWrapper = () => {
  const {currentUser} = useAuth()
  const peut = (code: string) => shouldDisplayFonctionnalite(currentUser, code)

  return (
    <Routes>
      {peut('SAV_PARAMETRER') && (
        <Route
          path='/parametres/messages'
          element={
            <>
              <PageTitle
                breadcrumbs={[
                  {title: 'Paramètres', path: '#', isSeparator: false, isActive: false},
                ]}
              >
                Messages SAV
              </PageTitle>
              <SavMessagesPage />
            </>
          }
        />
      )}
      {peut('SAV_PARAMETRER') && (
        <Route
          path='/parametres/referentiels'
          element={
            <>
              <PageTitle
                breadcrumbs={[
                  {title: 'Paramètres', path: '#', isSeparator: false, isActive: false},
                ]}
              >
                Référentiels SAV
              </PageTitle>
              <SavReferentielsPage />
            </>
          }
        />
      )}
      {peut('SAV_CONSULTER') && (
        <>
          <Route
            path='/liste'
            element={
              <>
                <PageTitle breadcrumbs={fil}>Liste</PageTitle>
                <SavListPage />
              </>
            }
          />
          <Route
            path='/dossiers/:id/qualification'
            element={
              <>
                <PageTitle breadcrumbs={fil}>Traitement du SAV</PageTitle>
                <SavQualificationPage />
              </>
            }
          />
          <Route
            path='/dossiers/:id/fiche'
            element={
              <>
                <PageTitle breadcrumbs={fil}>Traitement du SAV</PageTitle>
                <SavFichePage />
              </>
            }
          />
          <Route
            path='/dossiers/:id/solution'
            element={
              <>
                <PageTitle breadcrumbs={fil}>Traitement du SAV</PageTitle>
                <SavSolutionPage />
              </>
            }
          />
          <Route path='/dossiers/:id' element={<Navigate to='fiche' replace />} />
        </>
      )}
      {peut('SAV_RECEPTIONNER') && (
        <Route
          path='/reception'
          element={
            <>
              <PageTitle breadcrumbs={fil}>Réception quai</PageTitle>
              <SavReceptionPage />
            </>
          }
        />
      )}
      {peut('SAV_CONTROLER') && (
        <Route
          path='/controle'
          element={
            <>
              <PageTitle breadcrumbs={fil}>Contrôle labo</PageTitle>
              <SavControlePage />
            </>
          }
        />
      )}
      {peut('SAV_CREER') && (
        <Route
          path='/nouveau'
          element={
            <>
              <PageTitle breadcrumbs={fil}>Nouveau SAV</PageTitle>
              <SavSaisiePage />
            </>
          }
        />
      )}
      <Route index element={<Navigate to='liste' replace />} />
      <Route path='*' element={<Navigate to='/dashboard' />} />
    </Routes>
  )
}

export default SavWrapper
